import { createContextualCan } from '@casl/react';
import {AbilityContext} from "./AbilityContext";
import {buildAbilityFor} from "./ability";
import {appSession} from "../commons";
import {User} from "../commons/models/user";

const ability = buildAbilityFor(appSession.getUser() as User);
export default ability;
export const Can = createContextualCan(AbilityContext.Consumer);